<template>
  <div class="div-link">
    <a @click="$emit('click')">
      {{ text }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
.div-link {
  display flex
  justify-content  flex-end
  font-size 15px
  height 20px

  > a {
    cursor pointer
    color white
    text-decoration none

    &:hover {
      border-bottom 1px solid
    }
  }
}
</style>
